export default "__VITE_ASSET__CpM6eUNK__"